import React from 'react';
import { ALL_AUTHORIZATION_PAGE_STATUSES, ALL_AUTHORIZATION_PAGE_STATUSES_WITH_VOID } from 'common/Status/authorizationConstants';
import { useFeatureFlag } from 'common/hooks';
import ServiceAuthorizationWorkqueue from './ServiceAuthorizationWorkqueue';

const AllServiceAuthorizations = () => {
  const showVoidAuthorizations = useFeatureFlag('pays-5650-update-edit-authorizations');

  const authorizationStatuses = showVoidAuthorizations ?
    ALL_AUTHORIZATION_PAGE_STATUSES_WITH_VOID :
    ALL_AUTHORIZATION_PAGE_STATUSES;

  return (
    <ServiceAuthorizationWorkqueue
      authorizationStatus={authorizationStatuses}
      onlyConsentedPeople
    />
  );
};

export default AllServiceAuthorizations;
